'use strict';

var objectWithoutProperties = require('../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var Theme = require('../../Theme/Theme.js');
require('../../Theme/DarkTheme.js');
require('../../Theme/LightTheme.js');
var createMuiTheme = require('../../node_modules/@material-ui/core/esm/styles/createMuiTheme.js');
var ThemeProvider = require('../../node_modules/@material-ui/styles/esm/ThemeProvider/ThemeProvider.js');
var Button$1 = require('../../node_modules/@material-ui/core/esm/Button/Button.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var errorTheme = createMuiTheme(_objectSpread({}, Theme.theme, {
  palette: {
    primary: Theme.theme.palette.error
  }
}));

var Button = function Button(_ref) {
  var buttonText = _ref.buttonText,
      color = _ref.color,
      children = _ref.children,
      materialUIConfigurations = objectWithoutProperties(_ref, ["buttonText", "color", "children"]);

  if (color === 'error') {
    return React__default["default"].createElement(ThemeProvider, {
      theme: errorTheme
    }, React__default["default"].createElement(Button$1["default"], _objectSpread({
      color: "primary"
    }, materialUIConfigurations), buttonText, children));
  } else {
    return React__default["default"].createElement(Button$1["default"], _objectSpread({
      color: color
    }, materialUIConfigurations), buttonText, children);
  }
};

module.exports = Button;
